import { Box } from '@mui/material';
import EAButton from 'components/common/EAButton';
import EAIcon from 'components/common/EAIcon';
import i18next from 'i18next';
import { useContext, useEffect, useState } from 'react';
import {
  canReevaluate,
  getEvDataScopeChangeFieldValue,
  hasNoData,
  isNewEvaluation,
  showSpecificSharingMessage,
} from 'services/common/EcovadisUtils';
import {
  PrivilegeEnum,
  RoleBasedAccessControlContext,
} from 'services/common/RolesUtils';
import useStyles from 'style/js-style/components/thirdparties/ecovadis/EcovadisStyle';
import EcovadisEvaluationDialog from './EcovadisDialogs/EcovadisEvaluationDialog/EcovadisEvaluationDialog';
import { Context } from 'states/Store';
import EcovadisScopeChangePopper from './EcovadisScopeChangePopper';
import EAColorIcon from 'components/common/EAColorIcon';

const EcovadisStatusMessage = ({ evData, onRiskChange = () => {} }) => {
  const { classes } = useStyles();
  const [state,] = useContext(Context);
  const { hasAnyOfPrivileges } = useContext(RoleBasedAccessControlContext);
  const [isEvaluationPopupOpen, setIsEvaluationPopupOpen] = useState(false);
  const [message, setMessage] = useState("");

  useEffect(() => {
    if(hasNoData(evData)) {
      setMessage(i18next.t('ecovadis.messages.noEvaluation'));
    } else if(showSpecificSharingMessage(evData)) {
      setMessage(i18next.t(`ecovadis.messages.sharing.${getEvDataScopeChangeFieldValue(evData, 'sharing_status_code')}`));
    } else if(isNewEvaluation(evData)) {
      setMessage(i18next.t('ecovadis.messages.newEvaluation'));
    }
  }, [evData])

  return (
    <Box className={classes.rootNoData}>
      <EAIcon icon="notification_important" />
      <div className={classes.noDataText}>
        {message}
      </div>
      {canReevaluate(evData, state.thirdparty?.onboarded) && (
        <>
          <EAButton
            size="small"
            onClick={() => setIsEvaluationPopupOpen(true)}
            disabled={
              !hasAnyOfPrivileges(PrivilegeEnum.PRIVILEGE_EDIT_ECOVADIS_SOURCE)
            }
            colorVariant={'primaryLight'}
            content={
              <>
                <EAColorIcon icon="newEnrichment" className={classes.evaluateBtnIcon}/>
                <span>
                  {i18next.t(
                    hasNoData(evData)
                      ? 'ecovadis.evaluate'
                      : 'ecovadis.reevaluate'
                  )}
                </span>
              </>
            }
          />

          {isEvaluationPopupOpen && (
            <EcovadisEvaluationDialog
              isOpen={isEvaluationPopupOpen}
              onClose={() => setIsEvaluationPopupOpen(false)}
              onValidateSuccess={() => {
                setIsEvaluationPopupOpen(false);
                onRiskChange();
              }}
            />
          )}
        </>
      )}
      {evData?.scope_change && <EcovadisScopeChangePopper evData={evData} />}
    </Box>
  );
};

export default EcovadisStatusMessage;
